import React from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { useAppendAccountMutation } from "../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup"
import TextInput from "../../../../../../Common/components/text-input";
import SelectInput from "../../../../../../Common/components/select-input";
import { PARTNERS } from "../../../../../../../util/constants/Partners";

export const AppendTradingAccountModal = ({ showAppendTradingAccountModal, onHide, details }) => {
    const [
        AppendAccount, // This is the mutation trigger
        {
            isLoading: isAppending,
        }, // This is the destructured mutation result
    ] = useAppendAccountMutation()

    /* Change User Group */
    const onSubmit = (values) => {
        AppendAccount({
            partner: values?.partner,
            partnerId: values?.partnerId,
            accountId: values?.accountId,
            userId: details?.basic?.userId,
            userGroup: details?.basic?.userGroup,
            meta: {},
        })
            .unwrap()
            .then(() => {
                cogoToast.success("Created 'Append Trading Account' Action Successfully")
                onHide()
            })
    }

    return (
        <Modal
            show={showAppendTradingAccountModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isAppending ? "static" : true}
            keyboard={!isAppending}
        >
            <Formik
                initialValues={{
                    partner: "",
                    partnerId: "",
                    accountId: "",
                }}
                validationSchema={
                    Yup.object({
                        partner: Yup.string().required("required"),
                        partnerId: Yup.string().required("required"),
                        accountId: Yup.string().required("required"),
                    })
                }
                onSubmit={(values) => onSubmit(values)}
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {`Append Trading Account`}
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <SelectInput
                                label="Partner*"
                                name="partner"
                                options={PARTNERS}
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Partner ID*"
                                name="partnerId"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Account ID*"
                                name="accountId"
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isAppending}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isAppending}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Submit
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal>
    );
}
